var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content)?_c('div',[_vm._t("default",function(){return [_c('rhombus-icon',{staticClass:"indicator",attrs:{"title":"","size":13,"fillColor":_vm.fillColor}})]}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.titleCase(_vm.content)))])],2):_c('div',[_vm._v("-")])
}
var staticRenderFns = []

export { render, staticRenderFns }